export default "__VITE_ASSET__DQj2CdHA__"